import { createSelector } from '@reduxjs/toolkit'

export const SLICE_NAME = 'device'
const select = (state: any) => state[SLICE_NAME]
const getDevice = (state: any) => state[SLICE_NAME]
